/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIMeasurement } from './APIMeasurement';
import {
    APIMeasurementFromJSON,
    APIMeasurementFromJSONTyped,
    APIMeasurementToJSON,
} from './APIMeasurement';
import type { APIHumanReadableDuration } from './APIHumanReadableDuration';
import {
    APIHumanReadableDurationFromJSON,
    APIHumanReadableDurationFromJSONTyped,
    APIHumanReadableDurationToJSON,
} from './APIHumanReadableDuration';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIArticle
 */
export interface APIArticle {
    /**
     * 
     * @type {string}
     * @memberof APIArticle
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticle
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticle
     */
    number: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticle
     */
    hoopsPartId?: string;
    /**
     * 
     * @type {Date}
     * @memberof APIArticle
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIArticle
     */
    readonly lastModifiedAt: Date;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIArticle
     */
    weight?: APIMeasurement | null;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIArticle
     */
    length?: APIMeasurement | null;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIArticle
     */
    width?: APIMeasurement | null;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIArticle
     */
    height?: APIMeasurement | null;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIArticle
     */
    volume?: APIMeasurement | null;
    /**
     * 
     * @type {string}
     * @memberof APIArticle
     */
    barcodeText?: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticle
     */
    qualityClass?: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticle
     */
    countryOfOrigin?: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticle
     */
    description?: string;
    /**
     * 
     * @type {APIHumanReadableDuration}
     * @memberof APIArticle
     */
    leadTime?: APIHumanReadableDuration | null;
    /**
     * 
     * @type {boolean}
     * @memberof APIArticle
     */
    isBomBase?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIArticle
     */
    isImportedVersion?: boolean;
    /**
     * 
     * @type {string}
     * @memberof APIArticle
     */
    articleType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIArticle
     */
    family?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIArticle
     */
    brand?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIArticle
     */
    barcodeType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIArticle
     */
    material: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticle
     */
    variationOf?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIArticle
     */
    supplier?: string | null;
    /**
     * 
     * @type {Array<string | null>}
     * @memberof APIArticle
     */
    category?: Array<string | null>;
    /**
     * 
     * @type {Array<string | null>}
     * @memberof APIArticle
     */
    properties?: Array<string | null>;
    /**
     * 
     * @type {string}
     * @memberof APIArticle
     */
    readonly files: string;
    /**
     * 
     * @type {string}
     * @memberof APIArticle
     */
    readonly requests: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIArticle
     */
    readonly hasChildren: boolean;
    /**
     * 
     * @type {number}
     * @memberof APIArticle
     */
    readonly inStorage: number;
}

/**
 * Check if a given object implements the APIArticle interface.
 */
export function instanceOfAPIArticle(value: object): value is APIArticle {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('material' in value) || value['material'] === undefined) return false;
    if (!('files' in value) || value['files'] === undefined) return false;
    if (!('requests' in value) || value['requests'] === undefined) return false;
    if (!('hasChildren' in value) || value['hasChildren'] === undefined) return false;
    if (!('inStorage' in value) || value['inStorage'] === undefined) return false;
    return true;
}

export function APIArticleFromJSON(json: any): APIArticle {
    return APIArticleFromJSONTyped(json, false);
}

export function APIArticleFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIArticle {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'name': json['name'] == null ? undefined : json['name'],
        'number': json['number'],
        'hoopsPartId': json['hoops_part_id'] == null ? undefined : json['hoops_part_id'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'weight': json['weight'] == null ? undefined : APIMeasurementFromJSON(json['weight']),
        'length': json['length'] == null ? undefined : APIMeasurementFromJSON(json['length']),
        'width': json['width'] == null ? undefined : APIMeasurementFromJSON(json['width']),
        'height': json['height'] == null ? undefined : APIMeasurementFromJSON(json['height']),
        'volume': json['volume'] == null ? undefined : APIMeasurementFromJSON(json['volume']),
        'barcodeText': json['barcode_text'] == null ? undefined : json['barcode_text'],
        'qualityClass': json['quality_class'] == null ? undefined : json['quality_class'],
        'countryOfOrigin': json['country_of_origin'] == null ? undefined : json['country_of_origin'],
        'description': json['description'] == null ? undefined : json['description'],
        'leadTime': json['lead_time'] == null ? undefined : APIHumanReadableDurationFromJSON(json['lead_time']),
        'isBomBase': json['is_bom_base'] == null ? undefined : json['is_bom_base'],
        'isImportedVersion': json['is_imported_version'] == null ? undefined : json['is_imported_version'],
        'articleType': json['article_type'] == null ? undefined : json['article_type'],
        'family': json['family'] == null ? undefined : json['family'],
        'brand': json['brand'] == null ? undefined : json['brand'],
        'barcodeType': json['barcode_type'] == null ? undefined : json['barcode_type'],
        'material': json['material'],
        'variationOf': json['variation_of'] == null ? undefined : json['variation_of'],
        'supplier': json['supplier'] == null ? undefined : json['supplier'],
        'category': json['category'] == null ? undefined : json['category'],
        'properties': json['properties'] == null ? undefined : json['properties'],
        'files': json['files'],
        'requests': json['requests'],
        'hasChildren': json['has_children'],
        'inStorage': json['in_storage'],
    };
}

export function APIArticleToJSON(value?: Omit<APIArticle, 'self'|'created_at'|'last_modified_at'|'files'|'requests'|'has_children'|'in_storage'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'number': value['number'],
        'hoops_part_id': value['hoopsPartId'],
        'weight': APIMeasurementToJSON(value['weight']),
        'length': APIMeasurementToJSON(value['length']),
        'width': APIMeasurementToJSON(value['width']),
        'height': APIMeasurementToJSON(value['height']),
        'volume': APIMeasurementToJSON(value['volume']),
        'barcode_text': value['barcodeText'],
        'quality_class': value['qualityClass'],
        'country_of_origin': value['countryOfOrigin'],
        'description': value['description'],
        'lead_time': APIHumanReadableDurationToJSON(value['leadTime']),
        'is_bom_base': value['isBomBase'],
        'is_imported_version': value['isImportedVersion'],
        'article_type': value['articleType'],
        'family': value['family'],
        'brand': value['brand'],
        'barcode_type': value['barcodeType'],
        'material': value['material'],
        'variation_of': value['variationOf'],
        'supplier': value['supplier'],
        'category': value['category'],
        'properties': value['properties'],
    };
}

